





































































import { Component, Prop } from "vue-property-decorator";
import { DialogSection, DialogForm, FormText } from "sitewhere-ide-components";

import { VFlex } from "vuetify/lib";

import { required } from "vuelidate/lib/validators";
import { Validation } from "vuelidate";

@Component({
  components: { DialogForm, FormText, VFlex },
  validations: {
    hostname: {
      required
    },
    port: {
      required
    },
    maxConnections: {
      required
    },
    username: {
      required
    },
    password: {
      required
    }
  }
})
export default class Postgres95Fields extends DialogSection {
  dummy!: Validation;
  @Prop() readonly readonly!: boolean;

  hostname: string | null = null;
  port: number | null = null;
  username: string | null = null;
  password: string | null = null;
  maxConnections: number | null = null;

  /** Reset section content */
  reset(): void {
    this.hostname = null;
    this.port = null;
    this.username = null;
    this.password = null;
    this.maxConnections = null;
    this.$v.$reset();
  }

  /** Perform validation */
  validate(): boolean {
    this.$v.$touch();
    return !this.$v.$invalid;
  }

  /** Load form data from an object */
  /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
  load(configuration: any): void {
    this.hostname = configuration.hostname;
    this.port = configuration.port;
    this.username = configuration.username;
    this.password = configuration.password;
    this.maxConnections = configuration.maxConnections;
  }

  /** Save form data to an object */
  save(): {} {
    return {
      hostname: this.hostname,
      port: this.port,
      username: this.username,
      password: this.password,
      maxConnections: this.maxConnections
    };
  }
}
